const inView = require('in-view')

export default class Cards {
  constructor(el) {
    this.el = el
    this.filters = el.querySelector('[data-cards-filters]')
    this.content = this.el.querySelector('[data-cards-content]')
    this.currentTag = null

    if (this.filters) {
      this.filters.addEventListener('click', (e) => {
        e.preventDefault()
        this.filters.querySelectorAll('.is-active').forEach((el) => {
          el.classList.remove('is-active')
        })

        const tag = e.target.getAttribute('data-tag')
        // Allow unselecting current tag
        if (this.currentTag === tag) {
          this.currentTag = null
        }
        else {
          this.currentTag = tag
        }
        e.target.classList.add('is-active')
        this.update()
      })

      // Simulate click on the first filter, the first one should be checked by default.
      this.filters.querySelector('a').click()
    }
  }

  update() {
    const items = this.content.querySelectorAll('[data-tag]')
    items.forEach(el => {
      el.classList.toggle('hidden', !(el.getAttribute('data-tag') === this.currentTag || this.currentTag === null))
    })
    const visibleCards = this.content.querySelectorAll('[data-tag]:not(.hidden)')
    this.content.setAttribute('data-cards-count', visibleCards.length)

    inView('[data-animation]').check()
  }
}
